<template>
    <div class="container">
      <modal-grid
        :title="'Lista de Seleccionados'"
        :visible="visibleModal"
        :data="itemsOutput"
        @hide="visibleModal = !visibleModal"
      ></modal-grid> 
      <modal-detail
        :visible="visibleModalDetail"
        :title="'Detalles de Salida'"
        :size="'xl'"
        @hide="closeModalDetail"
      >
        <div v-if="salidaDetail">
          <vue-custom-scrollbar class="scroll-area-salida">
            <div class="info-registro">
              <div class="registros">
                <div class="registro">
                  <div class="font-weight-bold">Código: {{ salidaDetail.codigo }}</div>
                </div>
              </div>
              <div class="estado">
                <span v-html="templateState(salidaDetail)"></span>
              </div>
            </div>
            <div class="detalle-servicio">
              <div class="detalle">
                <div class="font-weight-bold">Fecha Solicitud :</div>
                <div class="valor">{{ salidaDetail.fecha_solicitud }}</div>
              </div>
              <div class="detalle">
                <div class="font-weight-bold">Fecha Aprobación :</div>
                <div class="valor">{{ salidaDetail.fecha_aprobacion }}</div>
              </div>
              <div class="detalle">
                <div class="font-weight-bold">Fecha Entrega :</div>
                <div class="valor">{{ salidaDetail.fecha_entrega }}</div>
              </div>
              <div class="detalle">
                <div class="font-weight-bold">Observaciones :</div>
                <div class="valor">{{ salidaDetail.observacion }}</div>
              </div>
            </div>
            <hr>
            <center><span class="font-weight-bold">LISTA Y CONTENIDO DE CAJAS</span></center>
            <div><span class="font-weight-bold"><u>Total Cajas: {{ salidaDetail.cajas.length }}</u></span></div>
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1" v-for="(item, index) in salidaDetail.cajas" :key="index">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="`detail-${index}`" variant="light">
                    <div class="d-flex">
                      <div class="mr-4"><b>N° {{ index+1 }}</b></div>
                      <div class="mr-4"><b>Gestión:</b> {{ item.gestion }}</div>
                      <div class="mr-4"><b>Código Interno:</b> {{ item.cod_interno }}</div>
                      <div class="ml-auto" v-if="item.cubi"><b>CUBI:</b> {{ item.cubi }}</div>
                    </div>
                  </b-button>
                </b-card-header>
                <b-collapse :id="`detail-${index}`" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text><span class="font-weight-bold">Total Carpetas: {{ item.carpetas_retiradas.length }}</span></b-card-text>
                    <template v-for="(row, idx) in item.carpetas_retiradas" >
                      <div :key="idx" class="grid-carpetas">
                        <center v-if="row.nro_declaracion" class="font-weight-bold">{{ row.nro_declaracion }}</center>
                        <center v-else class="font-weight-bold">{{ row.nro_registro }}</center>
                      </div>
                    </template>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </vue-custom-scrollbar>
          <div class="row my-2" v-if="salidaDetail.ingresado">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
              <b-button @click="detailReingreso" type="submit" class="float-right" variant="success">
                <i class="fa fa-reply-all" aria-hidden="true"></i> REINGRESO
              </b-button>
            </div>
          </div>
        </div>
      </modal-detail>
      <modal-detail
        :visible="visibleModalDetailReingreso"
        :title="'Detalles de Reingreso'"
        :size="'xl'"
        @hide="closeModalDetailReingreso"
      >
        <div v-if="reingresoDetail">
          <vue-custom-scrollbar class="scroll-area-reingreso">
            <div class="info-registro">
              <div class="registros">
                <div class="registro">
                  <div class="font-weight-bold">Código: {{ reingresoDetail.codigo }}</div>
                </div>
              </div>
              <div class="estado">
                <span v-html="templateStateRentry(reingresoDetail)"></span>
              </div>
            </div>
            <div class="detalle-servicio">
              <div class="detalle">
                <div class="font-weight-bold">Fecha :</div>
                <div class="valor">{{ reingresoDetail.fecha }}</div>
              </div>
              <div class="detalle">
                <div class="font-weight-bold">Observaciones :</div>
                <div class="valor">{{ reingresoDetail.observacion }}</div>
              </div>
            </div>
            <hr>
            <center><span class="font-weight-bold">LISTA Y CONTENIDO DE CAJAS</span></center>
            <div><span class="font-weight-bold"><u>Total Cajas: {{ reingresoDetail.total_cajas }}</u></span></div>
            <div class="accordion" role="tablist">
              <b-card no-body class="mb-1" v-for="(item, index) in reingresoDetail.cajas" :key="index">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="`detail-rentry-${index}`" variant="light">
                    <div class="d-flex">
                      <div class="mr-4"><b>N° {{ index+1 }}</b></div>
                      <div class="mr-4"><b>Gestión:</b> {{ item.gestion }}</div>
                      <div class="mr-4"><b>Código Interno:</b> {{ item.cod_interno }}</div>
                      <div class="ml-auto" v-if="item.cubi"><b>CUBI:</b> {{ item.cubi }}</div>
                    </div>
                  </b-button>
                </b-card-header>
                <b-collapse :id="`detail-rentry-${index}`" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div v-if="Object.keys(item.carpetas).length > 0">
                      <div class="font-weight-bold"><u>Contenido No Ingresado</u></div>
                      <template v-for="(row, idx) in item.carpetas.retiradas" >
                        <div :key="row.id" class="grid-carpetas">
                          <center v-if="row.nro_declaracion" class="font-weight-bold">{{ row.nro_declaracion }}</center>
                          <center v-else class="font-weight-bold">{{ row.nro_registro }}</center>
                        </div>
                      </template>
                      <hr>
                      <div class="font-weight-bold"><u>Contenido Nuevo Ingresado</u></div>
                        <template v-for="(row, idx) in item.carpetas.agregadas" >
                          <div :key="row.id" class="grid-carpetas">
                            <center v-if="row.nro_declaracion" class="font-weight-bold">{{ row.nro_declaracion }}</center>
                            <center v-else class="font-weight-bold">{{ row.nro_registro }}</center>
                          </div>
                        </template>
                    </div>
                    <span v-else><b-alert show variant="warning"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Ingreso en el mismo estado.</b-alert></span>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </vue-custom-scrollbar>
          <div class="row my-2">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
              <b-button @click="downloadReingreso" class="float-right" variant="dark">
                <i class="fa fa-download" aria-hidden="true"></i>
              </b-button>
            </div>
          </div>
        </div>
      </modal-detail>
      <modal-questtion
        :title="'Alerta'"
        :visible="visibleModalQuestion"
        :alert_message="'Realmente desea cancelar esta solicitud?'"
        :loading="loadingDelete"
        @hide="visibleModalQuestion = !visibleModalQuestion"
        @submit="cancelSalida"
      >
      </modal-questtion>
      <div class="row">
        <div class="table-responsive">
          <div class="d-flex flex-sm-row flex-column bg-secondary">
            <div class="mr-auto p-2">
              <b-button @click="visibleModal = true" v-if="itemsOutput.length > 0" squared variant="outline-danger" class="mr-2">
                <i class="fa fa-check-square"></i>
                ({{ itemsOutput.length }}) Seleccionados
              </b-button>
              <b-button title="Quitar Seleccionados" @click="emptyGridSelected" variant="outline-dark">
                <i class="fa fa-check-square-o"></i>
              </b-button>
              <b-button title="Descargar Lista PDF" @click="pdfListOutput" variant="danger" class="ml-2">
                <i class="fa fa-file-pdf-o"></i>
                <span v-if="itemsOutput.length > 0">({{ itemsOutput.length }})</span>
              </b-button>
              <b-button title="Descargar Lista EXCEL" @click="excelListOutput" variant="success" class="ml-2">
                <i class="fa fa-file-excel-o"></i>
                <span v-if="itemsOutput.length > 0">({{ itemsOutput.length }})</span>
              </b-button>
            </div>
            <div class="p-2">
              <b-button title="Actualizar Tabla" @click="reloadTable" variant="dark" class="mr-2">
                <i class="fa fa-repeat"></i> Recargar
              </b-button>
            </div>
          </div>
          <kendo-datasource
            ref="data-output"
            :schema-total="'meta.total'"
            :schema-data="'data'"
            :transport-read="{ url: `${url}/salidas/agencia`, beforeSend: readData }"
            :transport-parameter-map="parameterMap"
            :page-size="10"
            :server-paging="true"
            :server-filtering="true"
            :server-sorting="true"
            :schema-model-fields="dsSchemaFields"
          ></kendo-datasource>
          <kendo-grid
            ref="gridOutput"
            :data-source-ref="'data-output'"
            :no-records="true"
            :messages-no-records="'NO EXISTEN RESULTADOS'"
            :groupable="true"
            :filterable="filterableConfig"
            :navigatable="true"
            :pageable-always-visible="true"
            :pageable-page-sizes="[10, 20, 50, 100]"
            :pageable-button-count="3"
            :pageable-responsive="true"
            :pageable-refresh="true"
            :sortable="true"
            :resizable="true"
            @change="onChange"
            @databound="dataBound"
          >
            <kendo-grid-column :selectable="true" :width="30"></kendo-grid-column>
            <kendo-grid-column
              :field="'codigo'"
              :title="'CÓDIGO'"
              :width="80"
              :filterable-cell-operator="'contains'"
              :filterable-cell-suggestion-operator="'contains'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'fecha_solicitud'"
              :title="'FECHA SOLICITUD'"
              :width="100"
              :format="'{0:dd/MM/yyyy}'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'fecha_aprobacion'"
              :title="'FECHA APROBACIÓN'"
              :width="100"
              :format="'{0:dd/MM/yyyy}'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'fecha_entrega'"
              :title="'FECHA ENTREGA'"
              :width="100"
              :format="'{0:dd/MM/yyyy}'"
            ></kendo-grid-column>
            <kendo-grid-column
              :field="'estado'"
              :title="'ESTADO'"
              :width="70"
              :template="templateState"
              :filterable-cell-show-operators="false"
              :filterable-cell-template="stateFilter"
            ></kendo-grid-column>
            <kendo-grid-column
              :command="[{className: 'k-grid-detail', name: 'detail', text: '', iconClass: 'fa fa-wpforms', click: detailSalida},{className: 'k-grid-download', name: 'download', text: '', iconClass: 'fa fa-download', click: downloadSalida},{className: 'k-grid-cancel', name: 'cancel', text: '', iconClass: 'fa fa-ban', click: questioncancelSalida},{className: 'k-grid-edit', name: 'edit', text: '', iconClass: 'fa fa-edit', click: editSalida}]" 
              :width="80"
            ></kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import $ from "jquery"
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import permission from '../../mixins/permission'
  import { mapGetters } from "vuex"
  import { API_URL } from "../../services/config"
  import ModalDetail from "../widgets/Modals/ModalDetail.vue"
  import ModalGrid from "../widgets/Modals/ModalGridSelectedList.vue"
  import ModalQuestion from "../../components/widgets/Modals/ModalQuestion.vue"
  import Outputervice from '../../services/output.service'
  
  export default {
    data() {
      return {
        url: API_URL,
        dsSchemaFields: {
          codigo: { type: "string" },
          fecha_solicitud: { type: "date", format: "{0:dd/MM/yyyy}" },
          fecha_aprobacion: { type: "date", format: "{0:dd/MM/yyyy}" },
          fecha_entrega: { type: "date", format: "{0:dd/MM/yyyy}" },
          estado: { type: "string" },
        },
        filterableConfig: {
          mode: "row",
          operators: {
            string: {
              qe: "Es igual a",
              neq: "No es igual a",
              contains: "Contiene",
              doesnotcontain: "No contiene",
              startswitch: "Comienza con",
              endswitch: "Termina en"
            },
            date: {
              lte: "Antes o igual a",
              gte: "Después o igual a"
            }
          }
        },
        visibleModal: false,
        visibleModalDetail: false,
        visibleModalQuestion: false,
        loadingDelete: false,
        salidaDetail: null,
        salidaId: null,
        visibleModalDetailReingreso: false,
        reingresoDetail: null
      }
    },
  
    computed: {
      ...mapGetters(["itemsOutput"])
    },
  
    components: {
      "modal-detail": ModalDetail,
      "modal-grid": ModalGrid,
      "modal-questtion": ModalQuestion,
      vueCustomScrollbar,
    },
  
    mixins: [permission],
  
    mounted() {
      let grid = this.$refs.gridOutput.kendoWidget()
      this.$bus.$on('evn-reload', () => {
        this.$refs.gridOutput.kendoWidget().dataSource.filter({})
      })
    },
  
    methods: {
      reloadTable() {
        this.$refs.gridOutput.kendoWidget().dataSource.filter({})
      },

      closeModalDetail() {
        this.visibleModalDetail = false
        this.salidaDetail = null
      },

      closeModalDetailReingreso() {
        this.visibleModalDetailReingreso = false
      },

      async detailSalida(ev) {
        ev.preventDefault()
        this.$store.dispatch("showLoader")
        let gridWidget = this.$refs.gridOutput.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        try {
          const response = await Outputervice.showOutput(`salidas/detalle/${data.id}`)
          if (response.status === 200) {
            this.salidaDetail = response.data.data
            this.$store.dispatch("hideLoader")
            this.visibleModalDetail = true
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async detailReingreso() {
        try {
          this.$store.dispatch("showLoader")
          const response = await Outputervice.showRentry({salida_id: this.salidaDetail.id})
          if (response.status === 200) {
            this.reingresoDetail = response.data.data
            this.visibleModalDetailReingreso = true
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async downloadSalida(ev) {
        ev.preventDefault()
        this.$store.dispatch("showLoader")
        let gridWidget = this.$refs.gridOutput.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        try {
          const response = await Outputervice.downloadOutput(data.id)
          if (response.status === 200) {
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      async downloadReingreso() {
        this.$store.dispatch("showLoader")
        try {
          const response = await Outputervice.downloadRentry(this.reingresoDetail.id)
          if (response.status === 200) {
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },

      questioncancelSalida(ev) {
        ev.preventDefault()
        let gridWidget = this.$refs.gridOutput.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        this.salidaId = data.id
        this.visibleModalQuestion = true
      },

      async cancelSalida() {
        try {
          this.loadingDelete = true
          const response = await Outputervice.cancelOutput(this.salidaId)
          if (response.status === 200) {
            this.loadingDelete = false
            this.visibleModalQuestion = false
            this.reloadTable()
            this.$message.success(response.data.message)
          }
        } catch (err) {
          if (err.response.status === 406) {
            this.loadingDelete = false
            this.visibleModalQuestion = false
            this.$notification.warning({
              message: 'Nota',
              description: err.response.data.message,
              duration: 10,
            })
          }
          this.loadingDelete = false
        }
      },

      async editSalida(ev) {
        ev.preventDefault()
        let gridWidget = this.$refs.gridOutput.kendoWidget()
        let tr = $(ev.target).closest('tr')
        let data = gridWidget.dataItem(tr)
        this.$emit("edit-output", data)
      },
  
      templateState(dataItem) {
        switch (dataItem.estado) {
          case "Pendiente":
            return (
              "<span class='badge badge-warning'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "Aprobado":
            return (
              "<span class='badge badge-success'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "Entregado":
            return (
              "<span class='badge badge-custom-1'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "Rechazado":
            return (
              "<span class='badge badge-danger'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          default:
            return (
              "<span class='badge badge-danger'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
        }
      },

      templateStateRentry(dataItem) {
        switch (dataItem.estado) {
          case "ANULADO":
            return (
              "<span class='badge badge-warning'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          case "RECIBIDO":
            return (
              "<span class='badge badge-success'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
            break;
          default:
            return (
              "<span class='badge badge-danger'>" +
              kendo.htmlEncode(dataItem.estado) +
              "</span>"
            );
        }
      },
  
      readData: function(xhr) {
        let self = this
        xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("access_token"))
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
        xhr.setRequestHeader("Accept-Language", "en")
        xhr.setRequestHeader("Accept", "application/json")
        xhr.done(function(data) {
          self.$emit("general", false)
        })
        xhr.fail(function(data) {
          if (data.status === 403) self.$router.push({ path: '/system/403' })
          if (data.status === 401 || data.responseJSON.message == "Unauthenticated.") {
            self.$store.dispatch('responseMessage', {
              type: 'warning',
              text: 'No tiene una sesión activa, por favor vuelva a iniciar sesión.',
              title: 'Sesión Expirada!',
              modal: true
            })
            .then(async() => {
              await self.$store.dispatch('cleanSession')
              self.$router.push({ path: '/system/login' })
            })
          }
        })
      },
  
      stateFilter(element) {
        let condition = [
          { title: "PENDIENTE", id: 0 },
          { title: "APROBADO", id: 1 },
          { title: "ENTREGADO", id: 2 },
          { title: "RECHAZADO", id: 3 },
        ]

        element.element.kendoDropDownList({
          dataSource: condition,
          dataTextField: "title",
          change: function(e) {},
          valuePrimitive: true,
          dataValueField: "id",
          optionLabel: {
            title: "-Seleccione-",
            id: ""
          }
        })
      },
  
      parameterMap: function(data, type) {
        if (type == "read" && data.filter) {
          let dates = data.filter.filters.filter(
            e => e.operator == "lte" || e.operator == "gte"
          )
          if (dates.length > 0) {
            data.filter.filters.forEach(item => {
              if (dates.includes(item)) {
                item.value = kendo.toString(item.value, "yyyy-MM-dd")
              }
            })
          }
          return data
        } else return data
      },
  
      emptyGridSelected() {
        this.$store.dispatch("emptyOutput")
        .then(() => {
          let grid = this.$refs.gridOutput.kendoWidget()
          grid.clearSelection()
        })
      },
  
      onChange(e) {
        let vm = this
        let grid = e.sender
        let items = grid.items()
        items.each(function(idx, row) {
          let idValue = grid.dataItem(row).get("id")
          let index = vm.itemsOutput.findIndex(x => x.id == idValue)
          if (row.className.indexOf("k-state-selected") >= 0) {
            let {parent, dirty, dirtyFields, _events, _handlers, uid,...obj} = grid.dataItem(row)
            obj.fecha_solicitud = kendo.toString(obj.fecha_solicitud, "dd/MM/yyyy")
            obj.fecha_aprobacion = kendo.toString(obj.fecha_aprobacion, "dd/MM/yyyy")
            obj.fecha_entrega = kendo.toString(obj.fecha_entrega, "dd/MM/yyyy")
            vm.$store.dispatch("setItemOutput", obj)
          } else if (index > -1) {
            vm.$store.dispatch("deleteItemOutput", index)
          }
        })
      },
  
      dataBound(e) {
        let vm = this
        let grid = e.sender
        let items = grid.items()
        let itemsToSelect = []
        items.each(function(idx, row) {
          let dataItem = grid.dataItem(row).get("id")
          let estado = grid.dataItem(row).get("estado")
          if (estado == 'Entregado') {
            $(this).find(".k-grid-edit").addClass("k-state-disabled");
            $(this).find(".k-grid-cancel").addClass("k-state-disabled");
          }
          let index = vm.itemsOutput.some(item => item.id === dataItem)
          if (index) {
            itemsToSelect.push(row)
          }
        })
  
        e.sender.select(itemsToSelect)
  
        grid.element.on("click", "tbody tr[data-uid] td:nth-child(2)", function(e) {
          let element = e.target || e.srcElement
          let {parent, dirty, dirtyFields, _events, _handlers, uid,...obj} = grid.dataItem($(element).closest("tr"))
          vm.employee = obj
          vm.work_orders = Array.from(obj.work_orders)
          vm.visibleDetail = true
        })
      },

      async pdfListOutput() {
        this.$store.dispatch("showLoader")
        let data = this.itemsOutput.map(item => item.id)
        try {
          const response = await Outputervice.pdfListOutput({salida: data})
          if (response.status === 200) {
            let file = new Blob([response.data], {type: 'application/pdf'})
            let fileUrl = URL.createObjectURL(file)
            window.open(fileUrl) 
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      },
  
      async excelListOutput() {
        this.$store.dispatch("showLoader")
        let data = this.itemsOutput.map(item => item.id)
        try {
          const response = await Outputervice.excelListOutput({salida: data})
          if (response.status === 200) {
            let blob = new Blob([response.data])
            let link = document.createElement("a")
            link.href = window.URL.createObjectURL(blob)
            link.download = `lista-salidas.xlsx`
            link.click()
            this.$store.dispatch("hideLoader")
          }
        } catch (err) {
          this.$store.dispatch("hideLoader")
        }
      }
    }
  }
  </script>
  
  <style scoped src="../../assets/css/grid.css"></style>
  <style scoped>
  .info-registro {
    display: flex;
    justify-content: space-between;
    background-color: #edfffd;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .registros {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .estado {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .detalle-servicio {
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  .detalle {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .detalle:not(:last-child) {
    border-bottom: 1px solid #d3d2d2;
  }

  .grid-carpetas {
    border: 1px solid black; 
    width: 122px; 
    display: inline-block; 
    margin-left: 4px;
    background-color: #ecfff4;
  }

  .scroll-area-salida {
    position: relative;
    margin: auto;
    height: 530px;
  }

  .scroll-area-reingreso {
    position: relative;
    margin: auto;
    height: 450px;
  }
  </style>